import React,{useState,useEffect} from 'react'
import './market.css'
import Footer from '../../Home/Home_modules/Footerr/footer'
import TopAuction from '../Marketplace/topauction';
import firebase from 'firebase/compat/app';
import { Link } from "react-router-dom";
import { CarouselWrapper } from "react-pretty-carousel";
import Carousel from './marketCarousel'
 

function Market (){

    const [NFTData, setNFTData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [items, setItems] = useState(3);
    const [carouselData, setCarouselData] = useState([]);

    const handleFilter = (event) =>{
        const selectValue =event.target.value;
        console.log(selectValue)
        let result = new Array();
        result = NFTData.filter((data) => {
            if ( parseInt(data.NFTUpdatedPrice) <= selectValue ){
                return data;
            } else if ( selectValue == 0){
                return data;
            } else if ( selectValue == data.auction){
                return data;
            }
            if ( data.nft.film_name == selectValue ){
                return data;
            } else if ( selectValue == "allmovie"){
                return data;
            }
            if (data.nft.celebrity == selectValue){
                return data;
            } else if(selectValue == "allactors"){
                return data;
            }
            if (data.nft.collection == selectValue){
                return data;
            } else if(selectValue == "allrarity"){
                return data;
            }
            });
            console.log(result);
            setFilteredData(result);
    }

    const handleSearch = (event) =>{
        const searchValue = event.target.value;
        console.log(searchValue);
        let result = new Array();
        result = NFTData.filter((data) => {
             if ( data.nft.nft_title.toLowerCase().indexOf(searchValue) > -1){
                 return data;
             } else if ( searchValue == ""){
                 return data;
             }
            });
            console.log(result);
            setFilteredData(result);
        }

    useEffect(() => {
        if (window.innerWidth < 350) setItems(1);
        else setItems(5);
        window.addEventListener("resize", () => {
          if (window.innerWidth < 10) setItems(1);
          else setItems(5);
        });

      const marketRef = firebase.firestore().collection('metadata');
  
      marketRef.get().then((snapshot) => {
        const data = snapshot.docs.map(doc => doc.data());
        console.log(data);
      setNFTData(data);
      setFilteredData(data);
      const nftArray = new Array();
      for(let i = 0; i < 5; i++){
          nftArray.push(
            <li className="box">
            <div id='first-card'className={
                                data[i].nft.collection=="Rare" ? "rare-card mplace-cards" 
                                : data[i].nft.collection =="Legendary" ? "legendary-card mplace-cards"
                                : data[i].nft.collection =="Ultimate" ? "ultimate-card mplace-cards" 
                                : "mplace-cards"}>
            <div className='mplace-card-menu'>
            <div className='mplace-card-menu-im'>
                <img />
                <img />
                <img />
            </div>
            <div className="mplace-card-menu-dt">
            <i class="fas fa-ellipsis-h"></i>
            </div>
            </div>
        <div className='mplace-card-im'>
        <Link to={`/nfttransfer/${data[i].nft.id}`}>
            <img src={data[i].nft.nft_thumb}style={{width: "100%", height: "300px"}} />
            </Link>
            </div>
        <div className='mplace-card-details'>
            <div className="mplace-cards-texts">
            <p>left</p>
            <Link to={`/nfttransfer/${data[i].nft.id}`}> <h2>{data[i].nft.nft_title}</h2> </Link>
            <h2>{data[i].nft.movie}</h2>
            <h6>{data[i].nft.collection}</h6>
            <p>{`${data[i].NFTUpdatedPrice}ETH`}</p>
            </div>
            <div className="mplace-card-like">
            <i class="fas fa-heart"></i>
            </div>
        </div>
        </div>
        </li>
          );
      }
      console.log(nftArray);
      setCarouselData(nftArray);
      });
      
  }, []); 
  
  console.log("Data",filteredData);
  

    return(
<>
<div className='mplace-main'>

    
                <div className="mplace-section1">
                <h1 className='mplace-title'>TOP AUCTIONS</h1>
                <Carousel data={carouselData}/>
               </div>
               <center>
                <div className='mplace-section-2'>
                    <div className="mplace-all-cards-section">
                        <div className="mplace-search-filter">
                            <div className="mplace-filter">
                            <i class="fas fa-filter"></i>
                            <select onChange={(event) =>handleFilter(event)} name="actors">
                            <option selected value="allrarity">Rarity</option>
                            <option value="Rare">Rare</option>
                            <option value="Ultimate">Ultimate</option>
                            <option value="Legendary">Legendary</option>
                        </select>
                            <select onChange={(event) =>handleFilter(event)} name="actors">
                            <option selected value="allmovie">Movie</option>
                            <option value="Kabali">Kabali</option>
                            <option value="Sivaji">Sivaji</option>
                            <option value="Chandramukhi">Chandramukhi</option>
                        </select>
                        <select  onChange={(event) => handleFilter(event)}  name="price-range">
                            <option selected value="0">Price range</option>
                            <option value="Yes">Auction</option>
                            <option value="10.00">$10</option>
                            <option value="20.00">$20</option>
                        </select>
                        <select onChange={(event) =>handleFilter(event)} name="actors">
                            <option selected value="allactors">All Actors</option>
                            <option value="Rajinikanth">Rajinikanth</option>
                            <option value="Vijay">Vijay</option>
                            <option value="Surya">Surya</option>
                        </select>
                            </div>
                            <div className="mplace-search">
                                <input onChange={ (event) => handleSearch(event) }id="mplace-search" type="text" placeholder='search nfts...' />
                                <i class="fas fa-search"></i>
                            </div>
                        </div>
                        <div  className='mplace-cards-list'>
                        {filteredData.map((data) => {

                        return(
                        
                            <div key={NFTData.TokenID} className={
                                data.nft.collection=="Rare" ? "rare-card mplace-cards-2" 
                                : data.nft.collection =="Legendary" ? "legendary-card mplace-cards-2"
                                : data.nft.collection =="Ultimate" ? "ultimate-card mplace-cards-2" 
                                : "mplace-cards-2"} >
                            <div className='mplace-card-menu2'>
                        <div className='mplace-card-menu-im2'>
                            <img />
                            <img />
                            <img />
                        </div>
                        <div className="mplace-card-menu-dt2">
                        <i class="fas fa-ellipsis-h"></i>
                        </div>
                        </div>
                    <div className='mplace-card-im2'>
                    <Link to={`/nfttransfer/${data.nft.id}`}><img src={data.nft.nft_thumb} /></Link>
                        </div>
                    <div className='mplace-card-details2'>
                        <div className="mplace-cards-texts2" style={{paddingTop: '5px'}}>
                        <p>left</p>
                        <Link to={`/nfttransfer/${data.nft.id}`}><h2>{data.nft.nft_title}</h2></Link>
                        <h2 style={{paddingTop: '5px'}}>{data.NFTUpdatedPrice} ETH</h2>
                        </div>
                        <div className="mplace-card-like2">
                        <i class="fas fa-heart"></i>
                        </div>
                    </div>
                        </div>  
                        
                        )
                        }
                        )
                        }
                        </div>
                    </div>
                </div></center>
                </div>
                <Footer />
</>

    )
 

}

export default Market